import { render } from "./start.vue?vue&type=template&id=e9cc3214&scoped=true"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"

import "./start.vue?vue&type=style&index=0&id=e9cc3214&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9cc3214"]])

export default __exports__